export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '指标编码',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '指标内容',
      width:'200px'
    },
    {
      key: 'operate2019',
      dataIndex: 'operate2019',
      title: '2019年度',
      slot:'operate2019',
    },
    {
      key: 'operate2020',
      dataIndex: 'operate2020',
      title: '2020年度',
      slot:'operate2020',
    },
    {
      key: 'operate2021',
      dataIndex: 'operate2021',
      title: '2021年度',
      slot:'operate2021',
    },
    // {
    //   title: '平均分',
    //   slot:'pjf',
    // }
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
